import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DomainConfigService {
  private project: string = 'client';
  private firstproject: string = 'Client';
  private allproject: string = 'CLIENT';
  private projects: string = 'Clients';
  private allprojects: string = 'CLIENTS';
  private subject: string = 'chapitre';
  private firstsubject: string = 'Chapitre';
  private allsubject: string = 'CHAPITRE';
  private subjects: string = 'Chapitres';
  private allsubjects: string = 'CHAPITRES';

  constructor(){
    var userData = JSON.parse(localStorage.getItem('currentUser'));
    if(userData){
      this.setConfig(userData.comProject, userData.comSubject);
    }
    
  }

  setConfig(project: string, subject: string) {
    this.project = project;
    this.firstproject = project.charAt(0).toUpperCase() + project.slice(1).toLowerCase();
    this.allproject = project.toUpperCase();
    this.projects = this.firstproject+"s";
    this.allsubjects = this.projects.toUpperCase();
    this.subject = subject;
    this.firstsubject = subject.charAt(0).toUpperCase() + subject.slice(1).toLowerCase();
    this.allsubject = subject.toUpperCase();
    this.subjects = this.firstsubject+"s";
    this.allsubjects = this.subjects.toUpperCase();
  }

  getProject() { return this.project; }
  getFirstproject() { return this.firstproject; }
  getAllproject() { return this.allproject; }
  getProjects() { return this.projects; }
  getAllprojects() { return this.allprojects; }
  getSubject() { return this.subject; }
  getFirstsubject() { return this.firstsubject; }
  getAllsubject() { return this.allsubject; }
  getSubjects() { return this.allsubject; }
  getAllsubjects() { return this.allsubjects; }
}

